import { useMemo, useContext } from 'react';
import { Typography } from '@mui/material';
import { KrDetail } from '@workboard/ui-okr';
import { OrgConfigContext } from '../../context/OrgConfigContextProvider';

const flatKrs = (arr) =>
  arr.reduce((acc, val) => {
    acc.push(val);
    if (val.nestedKrs) {
      const nestedKrs = flatKrs(val.nestedKrs);
      nestedKrs.forEach((nestedKr) => {
        nestedKr.isNested = true;
      });
      acc.push(...nestedKrs);
    }
    return acc;
  }, []);

export const TeamKrList = ({
  teamName,
  krs,
}) => {
  const { isSemEnabled } = useContext(OrgConfigContext);
  const flattenKrs = flatKrs(krs);
  const details = useMemo(() => {
    return flattenKrs.map((kr) => {
      return (
        <KrDetail
          context={{
            location: 'CONVERSATION_MEETING_PAGE',
            locationDetail: 'Meeting_Conversation_Team_Key_Results',
            semEnabled: isSemEnabled,
          }}
          key={kr.id}
          kr={kr}
          data-krid={kr.id}
          isNestedKr={kr.isNested}
        />
      );
    });
  }, [flattenKrs]);
  return (
    <>
      <Typography
        variant="body"
        sx={{ marginLeft: '8px', textTransform: 'uppercase' }}
      >
        {teamName}
      </Typography>
      {details}
    </>
  );
};
